import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";

/**
 * @param {Object} props
 * @param {string[]} props.initialKeywords 기존 키워드 목록
 * @param {number} props.posterId 수정할 포스터 ID
 * @param {Function} props.onClose 모달 닫기
 * @param {Function} props.onUpdatePoster 포스터 수정 후 부모 컴포넌트 상태 갱신
 */
export default function EditKeywordModal({
                                             initialKeywords,
                                             posterId,
                                             onClose,
                                             onUpdatePoster,
                                         }) {
    const [keywords, setKeywords] = useState(initialKeywords);
    const [newKeyword, setNewKeyword] = useState("");

    // ESC 키로 닫기
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    // 배경 클릭 시 닫기
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    // 키워드 추가 (Enter 또는 , 입력 시)
    const handleAddKeyword = (e) => {
        if ((e.key === "Enter" || e.key === ",") && newKeyword.trim()) {
            e.preventDefault();
            const parts = newKeyword
                .replace(/,+$/, "") // 끝에 붙은 쉼표 제거
                .split(",")
                .map((part) => part.trim())
                .filter(
                    (part) => part.length > 0 && !keywords.includes(part)
                );
            if (parts.length > 0) {
                setKeywords((prev) => [...prev, ...parts]);
            }
            setNewKeyword("");
        }
    };

    // 키워드 제거
    const removeKeyword = (k) => {
        setKeywords((prev) => prev.filter((kw) => kw !== k));
    };

    // 키워드 수정 저장
    const handleSave = () => {
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/poster/edit/${posterId}`, {
                keywords,
            })
            .then((res) => {
                // 서버에서 갱신된 포스터 정보를 그대로 내려준다고 가정
                onUpdatePoster(res.data); // 부모 상태 업데이트
            })
            .catch((err) => console.error(err));
        alert('수정 완료 새로고침 해주세요')
    };

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 bg-gray-500 bg-opacity-40 flex items-center justify-center z-50"
            onClick={handleBackdropClick}
            role="dialog"
            aria-modal="true"
        >
            <div className="bg-white p-6 rounded-lg w-full max-w-md mx-4 shadow-lg">
                <h3 className="text-lg font-bold mb-4">키워드 수정</h3>

                <div className="flex flex-wrap gap-2 mb-3 max-h-32 overflow-y-auto">
                    {keywords.map((k, i) => (
                        <span
                            key={i}
                            className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm flex items-center gap-1"
                        >
              {k}
                            <button
                                onClick={() => removeKeyword(k)}
                                className="text-red-500 text-xs hover:text-red-700"
                            >
                ✕
              </button>
            </span>
                    ))}
                </div>

                <input
                    type="text"
                    value={newKeyword}
                    onChange={(e) => setNewKeyword(e.target.value.replace(/,/g, ""))}
                    onKeyDown={handleAddKeyword}
                    className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="키워드를 입력하고 Enter (쉼표 입력 불가)"
                />

                <div className="mt-4 flex justify-end gap-2">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded border hover:bg-gray-100"
                    >
                        취소
                    </button>
                    <button
                        onClick={handleSave}
                        className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                    >
                        저장
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}